module.exports = __webpack_public_path__ + "static/media/icon_checkout_black.43380b43.svg";